import { PaddleIconFilledRounded } from '@/components/icons'

import { ROUTE_CLUBS } from '@/constants/Routes'
import { Club, MyClub } from '@/types'

import { ClubBenefitBadge } from './ClubBenefitBadge'
import { useNavigate } from 'react-router-dom'

type Props = {
  club: Club | MyClub
  isMyClub?: boolean
}

export const ClubItem = ({ club }: Props) => {
  const navigate = useNavigate()

  const onNavigateDetail = () => {
    navigate(`${ROUTE_CLUBS}/${club.clubId}`, { relative: 'path' })
  }

  return (
    <div className="flex gap-x-2 md:w-[312px] px-4 py-3 bg-white rounded-2xl cursor-pointer" onClick={onNavigateDetail}>
      {club?.mediaUrl ? (
        <img src={club?.mediaUrl} className="w-10 h-10 rounded-full" alt="" />
      ) : (
        <div>
          <PaddleIconFilledRounded className="w-10 h-10 text-primary-500" />
        </div>
      )}

      <div className="flex flex-col">
        <span className="text-sm font-semibold text-navy-900">{club?.clubName}</span>
        <span className="text-xs font-normal text-navy-900 text-opacity-80">{club?.shortAddress}</span>
        <span className="text-xs font-normal text-navy-900 text-opacity-60">{club?.clubMemberCount} Members</span>
        {/* With the address and member count, because it is the same kind of fact about the club.
            The full list is behind it rather than beside it. */}
        <ClubBenefitBadge benefitTypes={club?.benefitTypes} clubId={club.clubId} clubName={club?.clubName ?? ''} />
      </div>
    </div>
  )
}
